import {apiFetch} from "@/utils";

function getSuiviGrfa(periodId, concept = 1, globalView = false) {
  return apiFetch(`dashboard-grfa/suivi-grfa?periodId=${periodId}&concept=${concept}&globalView=${globalView}`, false, false);
}

function getSuiviGrfaDetails(periodId, concept = 1, globalView = false) {
  return apiFetch(`dashboard-grfa/details/suivi-grfa?periodId=${periodId}&concept=${concept}&globalView=${globalView}`, true, false);
}

export {getSuiviGrfa, getSuiviGrfaDetails}



// WEBPACK FOOTER //
// ./src/utils/dashboardGrfa.js